var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidePassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.443,
    height: 16.673,
    viewBox: "0 0 23.443 16.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hide_Icon",
    "data-name": "Hide Icon",
    transform: "translate(0 1.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Show_Icon",
    "data-name": "Show Icon",
    d: "M37.744,37.655C36.231,34.269,31.529,32,26.071,32S15.912,34.269,14.4,37.655a.726.726,0,0,0,0,.526c1.512,3.387,6.214,5.655,11.672,5.655s10.16-2.269,11.672-5.655A.726.726,0,0,0,37.744,37.655Zm-7.069.263a4.6,4.6,0,1,1-4.6-4.6A4.617,4.617,0,0,1,30.675,37.918Zm-14.927,0c.986-1.841,3.222-3.321,6.05-4.044a5.881,5.881,0,0,0,0,8.088C18.97,41.239,16.7,39.76,15.747,37.918Zm14.631,4.044a5.881,5.881,0,0,0,0-8.088c2.828.756,5.063,2.2,6.05,4.044C35.442,39.76,33.173,41.239,30.379,41.962Zm-6.938-4.044a2.63,2.63,0,1,1,2.63,2.63A2.638,2.638,0,0,1,23.441,37.918Z",
    transform: "translate(-14.35 -30.805)",
    fill: "#88818d"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x1: 14.734,
    y2: 13.846,
    transform: "translate(4.076)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassIcon);
export default __webpack_public_path__ + "static/media/hide-pass-icon.70f1972e.svg";
export { ForwardRef as ReactComponent };